import React, { useState } from 'react';
import {
  Title2,
  Body1,
  Tab,
  TabList,
  type SelectTabData,
  type SelectTabEvent,
} from '@fluentui/react-components';
import { useHelpPageStyles } from '../styles/HelpPage.styles';
import { HELP_PAGE_DESCRIPTION, HELP_PAGE_TITLE } from '../constants/helpContent';
import { FaqsTab } from './Help/FaqsTab';
import { SupportTab } from './Help/SupportTab';

type TabId = 'faqs' | 'support';

export const HelpPage: React.FC = () => {
  const styles = useHelpPageStyles();
  const [selectedTab, setSelectedTab] = useState<TabId>('faqs');

  const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value as TabId);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Title2>{HELP_PAGE_TITLE}</Title2>
          <Body1>{HELP_PAGE_DESCRIPTION}</Body1>
        </div>
      </div>

      <TabList selectedValue={selectedTab} onTabSelect={handleTabSelect}>
        <Tab value="faqs">FAQs</Tab>
        <Tab value="support">Support</Tab>
      </TabList>

      <div className={styles.tabContent}>
        {selectedTab === 'faqs' ? <FaqsTab /> : <SupportTab />}
      </div>
    </div>
  );
};
